module.exports = __webpack_public_path__ + "img/back-left-medal.701a6002.png";